import { useMemo } from 'react'
import { dateISOToDateAndTime, personName } from 'Data/format.js'
import formatDate from 'date-fns/format'
import { useDataChange } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
    path: 'set_default',
  })
  return useMemo(() => {
    if (!data) return data
    let default_sender_id = null
    if (data.defaults.length > 0) {
      default_sender_id = data.defaults[0].sender_id
    }
    if (data.emails.length === 0) {
      change(true)
    }
    return data.emails.map(comm => ({
      ...comm,
      default: comm.id === default_sender_id,
      // if it is default comms - check where the last update was made - email or default and use that.
      // otherwise use the email last updated
      last_updated:
        comm.id === default_sender_id
          ? data.defaults[0].updated_at > comm.updated_at
            ? {
                updated_by: personName(
                  data.defaults[0].updated_by_user?.vaxiom_person
                ),
                updated_at: dateISOToDateAndTime(data.defaults[0].updated_at),
              }
            : {
                updated_by: personName(comm.updated_by_user?.vaxiom_person),
                updated_at: dateISOToDateAndTime(comm.updated_at),
              }
          : {
              updated_by: personName(comm.updated_by_user?.vaxiom_person),
              updated_at: dateISOToDateAndTime(comm.updated_at),
            },
    }))
  }, [data])
}
